import Snackbars from './Snackbars';

export default Snackbars;
